/**
 *
 * SideNavigation Component
 *
 */
import { List, ListSubheader } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import SideNavItem from './components/SideNavItem';
import useStyles from './styles';

type NavItem = {
  customComponent?: React.ReactNode;
  href?: string;
  id?: string;
  isDisabled?: boolean;
  label: string;
  isLink?: boolean;
};

type SideNavProps = {
  items: NavItem[];
  className?: string;
  title?: string;
  currentPathName?: string;
};

export default function SideNavigation({ items, className, title, currentPathName }: SideNavProps): JSX.Element {
  const classes = useStyles();
  return (
    <List
      aria-labelledby="nested-list-subheader"
      className={classNames(classes.navContainer, className)}
      component="nav"
      subheader={
        <ListSubheader className={classNames(classes.title, className)} component="div">
          {title}
        </ListSubheader>
      }
    >
      {items.map(item => (
        <SideNavItem key={item.id} {...item} currentPathName={currentPathName} />
      ))}
    </List>
  );
}
